import { generateAutomationName } from "../../../../../helpers/generateAutomationName";

export const collisionKeys = {
    container: generateAutomationName("home", ["topics", "modal", "collision", "container"]),
    title: generateAutomationName("home", ["topics", "modal", "collision", "title"]),
    subtitle: generateAutomationName("home", ["topics", "modal", "collision", "subtitle"]),
    body: generateAutomationName("home", ["topics", "modal", "collision", "body"]),
    footer: generateAutomationName("home", ["topics", "modal", "collision", "footer"]),
};
